import { ClearFilterSvg } from 'utils/svgs';
import { ClearFilterProps } from './types';
import styles from './index.module.scss';
import { Tooltip } from 'antd';

const ClearFilter = (props: ClearFilterProps) => {
	const { clearFilter } = props;
	return (
		<Tooltip title="Clear Filter" placement="bottom">
			<div onClick={clearFilter} className={styles['clear-filter-button']}>
				<ClearFilterSvg />
			</div>
		</Tooltip>
	);
};

export default ClearFilter;
